import { IProductTagConfig, ITagsConfig } from 'mod/product-list/useProductContext';
import { tagsConfig } from 'mod/product/config';
import { toRecord } from 'base/utils/data';

type IProps = {
    tag: string; //商品标签
    tags: ITagsConfig; //模块配置
}

export type IProductTagsInstance = {
    productTag: false | IProductTagConfig;
}

// 仅显示 tagsConfig 中配置的商品标签
function getProductTag(tag: string, configedTags: string[]): string {
    return configedTags.includes(tag.toLowerCase()) ? tag : '';
}

export const useProductTags = (props: IProps): IProductTagsInstance => {
    const { tag, tags: config } = props;
    let productTag = config.productTag === false ? false : toRecord(config.productTag) as IProductTagsInstance['productTag'];

    if (productTag) {
        const tagName = getProductTag(tag, Object.keys(tagsConfig.product));
        productTag = !tagName ? false : Object.assign({
            tagName,
            discountStyle: '',
        }, productTag);
    } else {
        productTag = false;
    }

    return {
        productTag,
    }
};

export default useProductTags